import React from "react";
import { createContext } from "react";
import { GraphDataset } from './models/GraphDataset.interface';
import { GraphEdge } from "./models/GraphEdge.interface";
import { GraphNode } from "./models/GraphNode.interface";





export class GDataContextManager {
    private nodeMap = new Map<string, GraphNode>();
    private nodeEdgesMap = new Map<string, GraphEdge[]>();
    constructor(
        public dataset?: GraphDataset,
        public createdAt?: Date, 
        public hasError = false,
        public retry = () => undefined
    ) {
        if (!hasError && dataset) {
            this.initNodeMap();
        }

    }
    private initNodeMap() {
        if (!this.dataset) {
            return;
        }
        this.dataset.nodes.forEach(n => {
            this.nodeMap.set(n.id, n);
            this.nodeEdgesMap.set(n.id, []);
        })

        this.dataset.edges.forEach(e => {
            this.nodeEdgesMap.get(e.source).push(e);
            this.nodeEdgesMap.get(e.target).push(e);
        })

    }
    getNode(nodeId: string): GraphNode {
        if (!this.nodeMap.has(nodeId)) {
            return undefined;
        }
        return this.nodeMap.get(nodeId);
    }

    getOutboundEdges(nodeId: string): GraphEdge[] {
        return this.getEdges(nodeId).filter(e => e.source === nodeId);
    }

    getInboundEdges(nodeId: string): GraphEdge[] {
        return this.getEdges(nodeId).filter(e => e.target === nodeId);
    }

    getEdges(nodeId:string): GraphEdge[] {
        return this.nodeEdgesMap.get(nodeId);
    }

    getEdgesBetween(sourceNodeId: string, targetNodeId: string): GraphEdge[] {
        return this.dataset.edges.filter(e => e.source === sourceNodeId && e.target === targetNodeId);
    }
}



export const GDataContext = createContext<GDataContextManager>(new GDataContextManager());


export function useProvidedGData(): GDataContextManager | undefined {
    const context = React.useContext(GDataContext);
    if (context === undefined) {
        throw new Error('GraphDatasetContext not provided.');
    }
    return context;
}